import { render, staticRenderFns } from "./RDashboardTypeCard.vue?vue&type=template&id=509fa54c&scoped=true&"
import script from "./RDashboardTypeCard.vue?vue&type=script&lang=js&"
export * from "./RDashboardTypeCard.vue?vue&type=script&lang=js&"
import style0 from "./RDashboardTypeCard.vue?vue&type=style&index=0&id=509fa54c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509fa54c",
  null
  
)

export default component.exports